import { EnvLoadModule } from './env-load/env-load.module';
import {NgModule} from '@angular/core';
import {Location, APP_BASE_HREF} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpModule, Http, RequestOptions, XHRBackend} from '@angular/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginAuth} from './shared/authentications';

import {CustomHttp, PubSubService} from './shared/utils';

import {HeaderComponent, FooterComponent, MsgPopupComponent, PageTitleComponent} from './components';

import {environment} from '../environments/environment';
import {AlertGuard} from './shared/authentications/src/alert.guard';
import {AlertNewGuard} from './shared/authentications/src/alert-new.guard';
import {EscalationGuard} from './shared/authentications/src/escalation.guard';
import {EscalationNewGuard} from './shared/authentications/src/escalation-new.guard';
import {ExtensionGuard} from './shared/authentications/src/extension.guard';
import {IncidentGuard} from './shared/authentications/src/incident.guard';
import {IncidentNewGuard} from './shared/authentications/src/incident-new.guard';
import {IntegrationGuard} from './shared/authentications/src/integration.guard';
import {IntegrationNewGuard} from './shared/authentications/src/integration-new.guard';
import {PersonalMyinfoGuard} from './shared/authentications/src/personal-myinfo.guard';
import {PersonalAdditionalGuard} from './shared/authentications/src/personal-additional.guard';
import {NotificationRuleGuard} from './shared/authentications/src/notification-rule.guard';
import {ServiceGuard} from './shared/authentications/src/service.guard';
import {ServiceNewGuard} from './shared/authentications/src/service-new.guard';

import {IncidentResourceGuard} from './shared/authentications/src/incident-rsrc.guard';
import {AlertResourceGuard} from './shared/authentications/src/alert-rsrc.guard';
import {IntegrationResourceGuard} from './shared/authentications/src/integration-rsrc.guard';
import {ServiceResourceGuard} from './shared/authentications/src/service-rsrc.guard';
import {EscalationResourceGuard} from './shared/authentications/src/escalation-rsrc.guard';
import {ScheduleGuard} from './shared/authentications/src/schedule.guard';
import {ScheduleNewGuard} from './shared/authentications/src/schedule-new.guard';
import {ScheduleRsrcGuard} from './shared/authentications/src/schedule-rsrc.guard';
import {GuideGuard} from './shared/authentications/src/guide.guard';
import {AuthServices} from './shared/authentications/src/auth.services';
import {CommonServices} from './shared/services/src/api/common.services';
import {AppServices, KeycloakloginService, IntegratedKeycloakloginService} from './shared/services';
import {LocalStorageModule} from 'angular-2-local-storage';
import {FormsModule} from '@angular/forms';
/*import { ngxZendeskWebwidgetModule } from 'ngx-zendesk-webwidget';
import { ngxZendeskWebwidgetConfig} from 'ngx-zendesk-webwidget';*/

import {TeamServices} from './shared/services/src/api/team.services';
import {TeamGuard} from './shared/authentications/src/team.guard';
import {TeamResourceGuard} from './shared/authentications/src/team-rsrc.guard';

import {ScheduleServices} from './shared/services/src/api/schedule.services';
import {AnalyticsServices} from './shared/services/src/api/analytics.services';
import {AnalyticsSystemGuard} from './shared/authentications/src/analytics-system.guard';
import {EnvServices} from './shared/services';
import {PersonalSettingServices, UserServices} from './shared/services/src/api';
import {UserGuard} from './shared/authentications/src/user.guard';
import {UserResourceGuard} from './shared/authentications/src/user-rsrc.guard';

import {MsgPopupService} from './shared/services';
import {ExtensionNewGuard} from './shared/authentications/src/extension-new.guard';
import {ExtensionRsrcGuard} from './shared/authentications/src/extension-rsrc.guard';

import {GuideServices} from './shared/services/src/api';
import { SendNoticeGuard } from './shared/authentications/src/sendnotice.guard';
import { SendNoticeResourceGuard } from './shared/authentications/src/sendnotice-rsrc.guard';
import { LineConfigService } from './views/main/personalsetting/my-infomation/my-infomation.config';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    //화이트 레이블링 고민 필요
    return new TranslateHttpLoader(http, `${environment.apiUrl}/api/v1/1/common/dictionary/`, ''); // call to http(s)://domain:port/assets/i18n/{lang_code}.json //http://localhost:8080/api/v1/1/common/dictionary/
    //return new TranslateHttpLoader(http, `/assets/i18n/`, '.json');
}

export function httpFactory(backend: XHRBackend, defaultOptions: RequestOptions, pubsub: PubSubService) {
    return new CustomHttp(backend, defaultOptions, pubsub);
}

@NgModule({
    imports: [
        EnvLoadModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        }),
        LocalStorageModule.withConfig({
            prefix: 'alertNow',
            storageType: 'localStorage'
        })
    ],
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        MsgPopupComponent,
        PageTitleComponent
    ],
    providers: [
        TeamServices,
        UserServices,
        PersonalSettingServices,
        ScheduleServices,
        AuthServices,
        CommonServices,
        LoginAuth,
        AlertGuard,
        AlertNewGuard,
        EscalationGuard,
        EscalationNewGuard,
        ExtensionGuard,
        ExtensionNewGuard,
        ExtensionRsrcGuard,
        IncidentGuard,
        IncidentNewGuard,
        IntegrationGuard,
        IncidentResourceGuard,
        AlertResourceGuard,
        IntegrationResourceGuard,
        ServiceResourceGuard,
        EscalationResourceGuard,
        IntegrationNewGuard,
        PersonalMyinfoGuard,
        PersonalAdditionalGuard,
        NotificationRuleGuard,
        ServiceGuard,
        ServiceNewGuard,
        TeamGuard,
        TeamResourceGuard,
        ScheduleGuard,
        ScheduleNewGuard,
        ScheduleRsrcGuard,
        AnalyticsServices,
        AnalyticsSystemGuard,
        UserGuard,
        GuideGuard,
        UserResourceGuard,
        Location,
        AppServices,
        EnvServices,
        MsgPopupService,
        KeycloakloginService,
        IntegratedKeycloakloginService,
        GuideServices,
        SendNoticeGuard,
        SendNoticeResourceGuard,
        LineConfigService,
        {
            provide: Http,
            useFactory: httpFactory,
            deps: [XHRBackend, RequestOptions, PubSubService]
        },
        PubSubService,
        {provide: APP_BASE_HREF, useValue: '/'}
        //, { provide: LocationStrategy, useClass: HashLocationStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts